import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from './Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region GRAND TOTAL

function _GrandTotal(props) { return <LabelValue {...props} value={props.content} /> }
const GrandTotal = withLabelTokenParsing(_GrandTotal, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.GrandTotal:
            if (data.ExchangeRate && data.ExchangeRate.Total != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Total, options);
            }
            break;
        case Token.Total.GrandTotal:
            if (data.Total != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Total, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Grand Total', defaultValue, Token.Total.GrandTotal),
        Token.getWrappedTokenConfig('Grand Total (Display Currency)', Token.DisplayCurrency.GrandTotal)
    ];
};
const TypeConfig = {
    panel: {
        block: LabelValueTypeConfig.panel.block,
        description: LabelValueTypeConfig.panel.description,
        label: (display) => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: display || 'Grand Total' })),
        style: LabelValueTypeConfig.panel.style,
        value: (data) => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.GrandTotal}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.GrandTotal }))
    }
};

// #endregion GRAND TOTAL

export {
    GrandTotal as Component,
    Tokens,
    TypeConfig
}